import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { COVERAGE_FORM } from "@platform/rfp-core";
import { Typography } from "@platform/design-system";

import { SectionTitle } from "../../components";

const {
  FICA_OPTION,
  FICA_BILLABLE,
  FICA_MATCHING_YES,
  FICA_MATCHING_NO,
  FICA_MATCHING_UNKNOWN,
  BILLABLE,
  NOT_BILLABLE,
} = COVERAGE_FORM;

// STD-only FICA Matching (Yes/No/Unknown). When Yes, a required Billable /
// Not Billable choice appears; switching away from Yes clears it.
const FicaOptionSection = ({
  currentPlan,
  currentPlanErrors,
  planName,
  handlePlanFormChange,
  handlePreviousFieldsValidation,
  handlePlanFormChangeWithValidation,
}) => {
  const isFicaMatchingYes = currentPlan[FICA_OPTION] === FICA_MATCHING_YES;

  return (
    <>
      <SectionTitle>FICA Option</SectionTitle>
      <Box px={2}>
        <FormControl>
          <FormLabel id="fica-option-label" required>
            FICA Matching
          </FormLabel>
          <RadioGroup
            value={currentPlan[FICA_OPTION] ?? ""}
            row
            aria-labelledby="fica-option-label"
            name={FICA_OPTION}
            onChange={(e) => {
              // handlePlanFormChange clears ficaBillable in the same update when
              // FICA Matching moves off Yes.
              handlePlanFormChange(e.target, planName);
            }}
            onFocus={() => {
              handlePreviousFieldsValidation(FICA_OPTION, planName);
            }}
            onBlur={(e) => {
              handlePlanFormChangeWithValidation(e.target, planName);
            }}
          >
            <FormControlLabel
              value={FICA_MATCHING_YES}
              control={<Radio />}
              label={FICA_MATCHING_YES}
            />
            <FormControlLabel
              value={FICA_MATCHING_NO}
              control={<Radio />}
              label={FICA_MATCHING_NO}
            />
            <FormControlLabel
              value={FICA_MATCHING_UNKNOWN}
              control={<Radio />}
              label={FICA_MATCHING_UNKNOWN}
            />
          </RadioGroup>
        </FormControl>
        {isFicaMatchingYes && (
          <Box mt={1}>
            <FormControl>
              <FormLabel id="fica-billable-label" required>
                Billable
              </FormLabel>
              <RadioGroup
                value={currentPlan[FICA_BILLABLE] ?? ""}
                row
                aria-labelledby="fica-billable-label"
                name={FICA_BILLABLE}
                onChange={(e) => {
                  handlePlanFormChange(e.target, planName);
                }}
                onFocus={() => {
                  handlePreviousFieldsValidation(FICA_BILLABLE, planName);
                }}
                onBlur={(e) => {
                  handlePlanFormChangeWithValidation(e.target, planName);
                }}
              >
                <FormControlLabel
                  value={BILLABLE}
                  control={<Radio />}
                  label={BILLABLE}
                />
                <FormControlLabel
                  value={NOT_BILLABLE}
                  control={<Radio />}
                  label={NOT_BILLABLE}
                />
              </RadioGroup>
            </FormControl>
          </Box>
        )}
        <Box>
          {!!currentPlanErrors && (
            <Typography variant="caption" color="danger">
              {currentPlanErrors[FICA_OPTION]}{" "}
              {currentPlanErrors[FICA_BILLABLE]}
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

export default FicaOptionSection;
